import React from "react";
import { motion } from "framer-motion";

const ReportSection = ({
  developers,
  projects,
  selectedDev,
  selectedProject,
  report,
  onDeveloperChange,
  onProjectChange,
  onGenerate,
}) => {
  return (
    <motion.div
      className="bg-gray-800 p-6 rounded-2xl shadow-lg mb-8" 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <h2 className="text-xl font-semibold mb-4">Generate Developer Report</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-end">
        {/* Developer Dropdown */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1">
            Select Developer
          </label>
          <select
            value={selectedDev}
            onChange={onDeveloperChange}
            className="w-full px-3 py-2 bg-gray-700 rounded-md text-gray-100 focus:outline-none"
          >
            <option value="">-- Choose Developer --</option>
            {developers.map((dev) => (
              <option key={dev.id} value={dev.id}>
                {dev.username}
              </option>
            ))}
          </select>
        </div>

        {/* Project Dropdown */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-1">
            Select Project
          </label>
          <select
            value={selectedProject}
            onChange={onProjectChange}
            className="w-full px-3 py-2 bg-gray-700 rounded-md text-gray-100 focus:outline-none"
          >
            <option value="">-- Choose Project --</option>
            {projects.map((proj, idx) => (
              <option key={idx} value={proj}>
                {proj}
              </option>
            ))}
          </select>
        </div>

        {/* Generate Button */}
        <div className="text-right">
          <button
            onClick={onGenerate}
            className="bg-green-600 hover:bg-green-700 px-6 py-2 rounded-lg font-semibold transition duration-300"
          >
            Generate
          </button>
        </div>
      </div>

      {/* Report Output */}
      {report && (
        <div className="mt-6 bg-gray-700 p-4 rounded-lg">
          <h3 className="text-lg font-semibold mb-2 text-indigo-400">
            Report Summary
          </h3>
          <p>
            <strong>Developer:</strong> {report.developer_name}
          </p>
          <p>
            <strong>Project:</strong> {report.project_name}
          </p>
          <p>
            <strong>Total Hours:</strong> {report.total_hours} hrs
          </p>
        </div>
      )}
    </motion.div>
  );
};

export default ReportSection;
